<template>
    <th
        :style="containerStyle"
        :class="containerClass"
        role="columnheader"
        :data-p-frozen-column="frozen"
    >
        <div>
            {{ column.label }}<span v-if="column.required" class="requiredHeader"></span>
        </div>
    </th>
</template>

<script>
import DomHandler from '../../../common/DOMUtils.js';

export default {
    name: 'EditableHeaderCell',
    props: {
        column: {
            type: Object,
            required: true,
            validator: value => {
                return typeof value.label === 'string';
            }
        }
    },
    computed: {
        containerStyle() {
            return this.frozen ? this.styleObject : undefined;
        },
        containerClass() {
            if (this.frozen) {
                return 'table-frozen-column';
            }

            return undefined;
        },
        frozen() {
            return (
                Object.prototype.hasOwnProperty.call(this.column, 'frozen') && this.column.frozen
            );
        },
        alignFrozen() {
            return this.column.alignFrozen ?? 'left';
        }
    },
    data() {
        return {
            styleObject: {}
        };
    },
    methods: {
        updateStickyPosition() {
            if (this.frozen) {
                let align = this.alignFrozen;

                if (align === 'right') {
                    let right = 0;
                    let next = DomHandler.getNextElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (next) {
                        right = DomHandler.getOuterWidth(next) + parseFloat(next.style.right || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineEnd', right + 'px');
                } else {
                    let left = 0;
                    let prev = DomHandler.getPreviousElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (prev) {
                        left = DomHandler.getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineStart', left + 'px');
                }
            }
        }
    },

    mounted() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    },

    updated() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    }
};
</script>
